import { partnerElementCardType, type partnerElementDataType, typeElement } from "./types";

export const convertToDesign = (data: partnerElementDataType | undefined, type: typeElement) => {
  switch (type) {
    case typeElement.BACKGROUND:
      return data?.images?.find((img) => img.type === typeElement.BACKGROUND);
    case typeElement.DESCRIPTION:
      return data?.texts?.find((text) => text.type === typeElement.DESCRIPTION);
    case typeElement.LOGO:
      return data?.images?.find((img) => img.type === typeElement.LOGO);
    case typeElement.BANNER:
      return data?.images?.find((img) => img.type === typeElement.BANNER);
    case typeElement.TITLE:
      return data?.texts?.find((text) => text.type === typeElement.TITLE);
    case typeElement.HTML_TITLE:
      return data?.texts?.find((text) => text.type === typeElement.HTML_TITLE);
    case typeElement.FOOTER:
      return data?.texts?.find((text) => text.type === typeElement.FOOTER);
    case typeElement.FOOTER_INFO:
      return data?.texts?.find((text) => text.type === typeElement.FOOTER_INFO);
    case typeElement.BUTTON:
      return data?.buttons?.[0];
    case typeElement.HTML_TERM:
      return data?.texts?.find((text) => text.type === typeElement.HTML_TERM);
  }
};
export const convertToDesignCards = (
  data: partnerElementCardType | undefined,
  type: typeElement
) => {
  switch (type) {
    case typeElement.DESCRIPTION:
      return data?.texts?.find((text) => text.type === typeElement.DESCRIPTION);
    case typeElement.LOGO:
      return data?.images?.find((img) => img.type === typeElement.LOGO);
    case typeElement.BANNER:
      return data?.images?.find((img) => img.type === typeElement.BANNER);
    case typeElement.TITLE:
      return data?.texts?.find((text) => text.type === typeElement.TITLE);
    case typeElement.HTML_TITLE:
      return data?.texts?.find((text) => text.type === typeElement.HTML_TITLE);
    case typeElement.FOOTER:
      return data?.texts?.find((text) => text.type === typeElement.FOOTER);
    case typeElement.HTML_TERM:
      return data?.texts?.find((text) => text.type === typeElement.HTML_TERM);
    case typeElement.BACKGROUND:
      return data?.images?.find((img) => img.type === typeElement.BACKGROUND);

    default:
      return undefined;
  }
};
export const convertToDesignArray = (
  data: partnerElementCardType | undefined,
  type: typeElement
) => {
  switch (type) {
    case typeElement.STEP:
      return (data?.texts ?? [])
        ?.filter((text) => text.type === typeElement.STEP)
        ?.sort((a, b) => (a.order as number) - (b.order as number));
    case typeElement.HTML_STEP:
      return (data?.texts ?? [])
        ?.filter((text) => text.type === typeElement.HTML_STEP)
        ?.sort((a, b) => (a.order as number) - (b.order as number));
    default:
      return [];
  }
};

export const convertCardToDesign = (
  data: partnerElementCardType | undefined,
  type: typeElement
) => {
  switch (type) {
    case typeElement.CARD_BUTTON:
      return data?.button;
    case typeElement.BACKGROUND:
      return data?.images?.find((img) => img.type === typeElement.BACKGROUND);

    default:
      break;
  }
};
export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}
